// ---------------------------------------------------------------------------
// Helpers de EXIBIÇÃO do módulo Comercial.
//
// Só formatação para a UI — a validação de dígito-verificador fica em
// utils/validateCpfCnpj.js (reusada pelo InputCpfCnpj). O backend devolve os
// documentos só com dígitos; estas funções aplicam máscara apenas na exibição.
//
// `formatDocForDisplay` MUDOU DE CASA (2026-08-04): virou compartilhada em
// `src/utils/format.js` quando o Financeiro passou a usá-la. Importe de lá.
// ---------------------------------------------------------------------------

import { onlyDigits } from '../../../utils/format';

// CEP 00000-000. Aceita com ou sem máscara; trunca em 8 dígitos.
export function formatCep(value) {
   const digits = onlyDigits(value).substring(0, 8);
   return digits.replace(/^(\d{5})(\d)/, '$1-$2');
}

// Telefone BR para exibição. O backend armazena canônico: 55 + DDD + número
// (12 dígitos p/ fixo, 13 p/ celular). Exibe como +55 (62) 91234-5678. Também
// tolera valores sem DDI (10/11 dígitos), exibindo sem o +55.
export function formatPhoneForDisplay(phone) {
   const digits = onlyDigits(phone);
   if (!digits) return '—';

   // Descasca o DDI 55 quando presente no canônico (12 ou 13 dígitos).
   let hasDdi = false;
   let local = digits;
   if ((digits.length === 12 || digits.length === 13) && digits.startsWith('55')) {
      hasDdi = true;
      local = digits.slice(2);
   }

   let formatted;
   if (local.length === 11) {
      formatted = local.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
   } else if (local.length === 10) {
      formatted = local.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
   } else {
      return phone;
   }

   return hasDdi ? `+55 ${formatted}` : formatted;
}
